import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpStore } from '../../../stores/sign-up.store';
import { AuthLayout } from '../auth.layout';
import { Progress } from './progress';
import { TextField } from '@mui/material';
import { mixTrack, track } from '@services/mixpanel';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const nameInput = z.object({
  firstname: z.string().trim().nonempty('Field is required'),
  lastname: z.string().trim().nonempty('Field is required'),
});

export const FillNameStepPage = () => {
  const { email, firstName, setFirstName, lastName, setLastName } =
    useSignUpStore();
  const { watch, register, handleSubmit, formState } = useForm({
    defaultValues: { firstname: firstName, lastname: lastName },
    resolver: zodResolver(nameInput),
  });

  const firstNameWatch = watch('firstname');
  const lastNameWatch = watch('lastname');

  const { errors } = formState;

  const onSubmit = useCallback(
    async (values: { firstname: string; lastname: string }) => {
      setFirstName(values.firstname);
      setLastName(values.lastname);
      track({ type: 'Full Name Submitted', payload: { uid: '' } });

      navigate(PATHS.SIGN_UP_INSTAGRAM);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [],
  );

  const complete = firstNameWatch?.length && lastNameWatch?.length;

  if (!email) {
    navigate(PATHS.SIGN_UP);
    return null;
  }

  const handleContinueClick = () => {
    mixTrack({
      type: 'Full Name Submitted',
      payload: {},
    });
  };

  return (
    <AuthLayout showGoBack title={'Hi, nice to meet you! 👋'}>
      <div className="flex flex-col w-full items-center">
        <form
          className="mt-8 w-full flex flex-col gap-3 text-left"
          onSubmit={handleSubmit(onSubmit)}
        >
          <TextField
            autoFocus
            aria-label="First name"
            label="First name"
            type="text"
            required
            placeholder="Your first name"
            {...register('firstname')}
            helperText="This field is required"
            error={!!errors?.firstname}
          />
          <TextField
            label="Last name"
            aria-label="Last name"
            type="text"
            required
            placeholder="Your last name"
            {...register('lastname')}
            helperText="This field is required"
            error={!!errors?.lastname}
          />

          <PrimaryButton
            type="submit"
            className={`w-full mt-5`}
            disabled={!complete}
            onClick={handleContinueClick}
          >
            Continue
          </PrimaryButton>
        </form>

        <div className="absolute bottom-4">
          <Progress steps={2} stepsCompleted={1} />
        </div>
      </div>
    </AuthLayout>
  );
};
